<div class="h-screen flex justify-center items-center p-5 ">
  <div class=" border-2 rounded-xl h-full min-h-[800px] w-[400px] overflow-scroll flex flex-col p-1 relative">

    <div class="flex flex-col p-1">
      <img  [src]="applicantProject()?.personalInformation?.urlImage ?? ''" class=" h-40" >

      <span class="text-sm ">
    {{applicantProject()?.personalInformation?.title ?? ""}}
  </span>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col ">
        @if (applicantProject()?.personalInformation?.showTypesData?.includes(TypeInputPersonalInformation.NAME)){
          <mat-form-field appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="nombre" >
          </mat-form-field>
        }

        @if (applicantProject()?.personalInformation?.showTypesData?.includes(TypeInputPersonalInformation.PHONE)){

          <mat-form-field appearance="outline">

            <mat-label>Teléfono</mat-label>
            <input matInput formControlName="telefono" type="tel" >
          </mat-form-field>

        }
        @if (applicantProject()?.personalInformation?.showTypesData?.includes(TypeInputPersonalInformation.LOCALIZATION_CONFIGURATION)){

          <mat-form-field appearance="outline">
            <mat-label>{{typeLocalization}}</mat-label>
            <mat-select formControlName="estado">
              @for (item of data | keyvalue; track item) {
                <mat-option [value]="item.key"  >{{item.key}}</mat-option>
              }
            </mat-select>
          </mat-form-field>

        }


        @if (applicantProject()?.personalInformation?.showTypesData?.includes(TypeInputPersonalInformation.EMAIL)){

          <mat-form-field appearance="outline">
            <mat-label>Correo Electrónico</mat-label>
            <input matInput formControlName="correo" type="email" >
          </mat-form-field>
        }



        <button mat-stroked-button color="primary" type="submit"  >Entrar</button>
      </form>
    </div>

  </div>
</div>
